const messages = {
  title: "Consentimentos de marketing",
  required: "Obrigatório",
  answered: "✓ Respondido",
  read: "Lido",
  notRead: "Não lido",
  alreadyAnswered: "Já respondido",
  requiredQuestionsMustBeAccepted:
    "Tem de aceitar {count} pergunta(s) obrigatória(s)",
  pleaseAnswerQuestions: "Responda às seguintes perguntas:",
  iAccept: "Aceito",
  scrollToUnlock: "Desloque-se até ao fim para desbloquear",
  fieldRequired: "Este campo é obrigatório",
  scrollToContinue: "↓ Desloque-se até ao fim para continuar",
  saving: "A guardar...",
  saveConsents: "Guardar consentimentos",
  allRequiredAccepted: "✓ Todas as perguntas obrigatórias aceites",
  requiredConsentsCompleted:
    "{completed}/{total} consentimentos obrigatórios concluídos",
  selectConsentToView:
    "Selecione um consentimento na lista para ver o conteúdo",
  readAllContentFirst: "Leia primeiro todo o conteúdo: {names}",
  acceptAllRequiredIn:
    "Aceite todas as perguntas obrigatórias em: {names}",
  acceptAllBeforeSaving:
    "Aceite todas as perguntas obrigatórias antes de guardar.",
  failedToSave:
    "Não foi possível guardar os consentimentos. Tente novamente.",
  errorSaving:
    "Ocorreu um erro ao guardar os consentimentos. Tente novamente.",
  failedToLoad:
    "Não foi possível carregar os consentimentos. Atualize a página.",
  viewPdf: "Ver PDF",
  requiredConsentTitle: "Consentimento obrigatório",
  acceptAndContinue: "Aceitar e continuar",
};

export default {
  messages,
};
